import { Trans } from '@lingui/macro';
import { ArrowLeft, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useHistory } from "../../hooks/useRouterCompat";
import { UserReport } from "../../models/UserReport";
import { Fire } from "../../services/FireClient";
import MessageItem from "../components/MessageItem";
import { UIMessage } from "../components/UIMessage";
import { Button } from "../../components/ui/button";

class UIUserReport {
  constructor(public report: UserReport, public msg: UIMessage) {
  }
}

const AdminFlaggedPage: React.FC = ({ }) => {
  const history = useHistory();
  const [inProgress, setInProgress] = useState(false);
  const [reports, setReports] = useState<UIUserReport[]>([]);

  useEffect(() => {
    setInProgress(true);

    Fire.getFlaggedMessages().then(_reports => {
      let list: UIUserReport[] = [];
      _reports.forEach(r => list.push(new UIUserReport(r, new UIMessage(r.message, []))));
      setReports(list);
      setInProgress(false);
    });

  }, []);

  return (
    <div className="flex flex-col h-screen bg-slate-50">
      <header className="flex items-center px-4 h-14 border-b bg-white shrink-0 gap-2">
        <Button variant="ghost" size="icon" onClick={() => history.goBack()}>
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <h1 className="text-lg font-semibold flex-1 text-center"><Trans>Flagged Content</Trans></h1>
        <div className="w-10" /> {/* Spacer for centering title */}
      </header>

      {inProgress && (
        <div className="h-1 w-full bg-gray-100 overflow-hidden shrink-0">
          <div className="h-full bg-primary animate-progress" />
        </div>
      )}

      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        {reports.map((r) => {
          return (
            <div key={r.report.id} className="bg-white rounded-lg shadow-sm border p-4 relative group">
              <Button
                variant="ghost"
                size="icon"
                className="absolute top-2 right-2 h-8 w-8 text-gray-400 hover:text-red-500"
                onClick={() => deleteReport(r.report)}
              >
                <X className="w-4 h-4" />
              </Button>

              <div className="space-y-3">
                <div className="text-sm text-gray-500 pr-8">
                  <Trans>{r.report.byUser.name} ({r.report.byUser.email}) reported this message on room id "{r.msg.msg.roomId}"</Trans>
                </div>

                <div className="bg-slate-50 rounded-md border p-2">
                  <MessageItem m={r.msg} state={'old'} onMessageClick={doingNothing} />
                </div>
              </div>
            </div>
          )
        })}

        {!inProgress && reports.length === 0 && (
          <div className="text-center text-gray-500 mt-10">
            <Trans>No flagged content found</Trans>
          </div>
        )}
      </div>
    </div>
  );

  function doingNothing() {
  }

  function deleteReport(report: UserReport) {
    setReports(list => list.filter(r => r.report.id != report.id));
    Fire.deleteUserReport(report);
  }
};

export default AdminFlaggedPage;